import React from 'react';
import ApexNavbar from './ApexNavbar';
import ApexFooter from './ApexFooter';
import './ApexToS.css';

const ApexToS = () => {
  return (
    <div className="apex-tos-page">
      <ApexNavbar />
      <div className="apex-tos-content">
        <h1>Terms of Service</h1>
        {/* Added extra bottom margin via CSS in .apex-tos-content h1 */}
        <p>
          <em>
            These Terms of Service govern your use of all services offered through eaglescript.space and any of its sub-domains. By accessing or using any part of our site or services, you agree to be bound by the terms below.
          </em>
        </p>

        <br />
        <p><strong>1. Acceptance of Terms and Modifications</strong></p>
        <p>
          By using this website, you agree to comply with these Terms of Service, which may be updated or modified at any time without prior notice. Continued use of the site constitutes acceptance of the modified terms. Specific features or services may have additional guidelines or rules, which will also apply.
        </p>

        <br />
        {/* Updated color for section 3 */}
        <p style={{ color: "#707070" }}><strong>2. Exclusion Clause</strong></p>
        <p style={{ color: "#707070" }}>
          If you are currently employed by, have previously worked for, are affiliated with, or represent (either formally or informally) any of the following entities—Valve Corporation, FACEPUNCH STUDIOS LTD, Bohemia Interactive a.s., BattlEye Innovations, CEVO LLC, EasyAntiCheat Ltd., Turtle Entertainment GmbH, E-Sports Entertainment LLC, or any legal or investigative party acting on their behalf—you are strictly prohibited from accessing this site or any services provided by EAGLE SCRIPT.
        </p>

        <br />
        <p><strong>3. Services Description</strong></p>
        <p>
          EAGLE SCRIPT provides access to digital software through the sale of individual product keys. Each product key grants access to the software for a fixed usage period starting from the moment of activation within the software and is tied to your hardware ID (HWID). Once the validity period of a key expires, access to the software will be automatically deactivated. Continued use requires the purchase and activation of a new product key. All services are provided "AS IS." We reserve the right to modify, suspend, or discontinue any part of the service at any time, with or without notice. EAGLE SCRIPT is not liable for data loss, delays, or service interruptions under any circumstances.
        </p>
        <p>
          We reserve the right to modify or discontinue services at any time, with or without notice. We are not responsible for data loss, delays, or service interruptions.
        </p>

        <br />
        <p><strong>4. User Responsibilities</strong></p>
        <p>
          By using our services, you agree not to harm EAGLE SCRIPT, its platform, or its community in any manner. Misuse, abuse, or violation of these terms may result in access termination and potential legal action.
        </p>
        <p>
          If you disagree with these terms, you must cease all use of our site and services.
        </p>

        <br />
        <p><strong>5. Refund Policy</strong></p>
        <p>
          By purchasing a product key, you acknowledge that you are buying access to digital content and software. All sales are final. No refunds will be issued once access is granted.
        </p>
        <p>
          Chargebacks, disputes, or fraudulent activity will result in immediate access termination and possible legal action against you.
        </p>

        <br />
        <p><strong>6. Data Collection and User Responsibility</strong></p>
        <p>
          By using the services provided by EAGLE SCRIPT, you expressly agree that your IP address and hardware identification data (HWID), including identifying information from specific components of your computer system, may be collected and stored each time you log in or access the software. This data is used for license verification, fraud prevention, and to enforce usage limits tied to your product key.
        </p>
        <p>
          You acknowledge and agree that it is your sole responsibility to ensure that you are authorized to run the software on any device or system. EAGLE SCRIPT is not liable for any consequences, legal or otherwise, that result from executing the software in environments where its use is unauthorized or prohibited.
        </p>
        <p>
          By using our services, you accept full responsibility for where and how the script is executed and agree that any resulting consequences fall solely under your liability.
        </p>

        <br />
        <p><strong>7. User Conduct</strong></p>
        <p>
          You agree not to engage in any unlawful or harmful behavior on our platform. This includes (but is not limited to):
        </p>
        <p>
          (a) Posting or transmitting unlawful, abusive, defamatory, obscene, or harmful content<br />
          (b) Uploading viruses or other malicious code<br />
          (c) Impersonating others or misrepresenting your affiliation<br />
          (d) Harvesting user data without consent<br />
          (e) Spamming or unauthorized commercial activity<br />
          (f) Violating intellectual property rights or other applicable laws
        </p>

        <br />
        <p><strong>8. Content Submission</strong></p>
        <p>
          By submitting content to EAGLE SCRIPT, you grant us a non-exclusive, worldwide, royalty-free license to use, distribute, display, and modify that content.
        </p>
        <p>
          You confirm that you own or have permission to share such content and that it does not violate any laws or third-party rights.
        </p>
        <p>
          We reserve the right to remove or block content at our discretion.
        </p>

        <br />
        <p><strong>9. Third-Party Services</strong></p>
        <p>
          Our website may include advertisements or links to third-party services. Any such dealings are solely between you and the third party. EAGLE SCRIPT assumes no liability for third-party services, content, or actions.
        </p>

        <br />
        <p><strong>10. Indemnification</strong></p>
        <p>
          You agree to indemnify and hold EAGLE SCRIPT, its affiliates, partners, and team members harmless from any claim or demand, including reasonable legal fees, arising out of your use of the service, your violation of these Terms, or your infringement of any rights.
        </p>

        <br />
        <p><strong>11. No Warranties</strong></p>
        <p>
          All services and content are provided "AS IS" and "AS AVAILABLE." EAGLE SCRIPT disclaims all warranties, including merchantability, fitness for a particular purpose, and non-infringement.
        </p>
        <p>
          We do not guarantee that services will be error-free, uninterrupted, or secure.
        </p>

        <br />
        <p><strong>12. Limitation of Liability</strong></p>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, YOU AGREE THAT EAGLE SCRIPT SHALL NOT BE HELD RESPONSIBLE FOR ANY FORM OF DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES. THIS INCLUDES, BUT IS NOT LIMITED TO, LOSSES RELATED TO PROFITS, BUSINESS INTERRUPTION, USE OF THE SERVICE, LOSS OF DATA, GOODWILL, OR OTHER NON-TANGIBLE ASSETS – EVEN IF WE HAVE BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGES. THIS LIMITATION APPLIES TO, WITHOUT LIMITATION: (I) YOUR ACCESS TO OR INABILITY TO ACCESS OR USE THE SOFTWARE OR PRODUCT KEY SERVICES, (II) ANY COSTS INCURRED FROM OBTAINING REPLACEMENT SERVICES OR PRODUCTS, (III) UNAUTHORIZED ACCESS, ALTERATION, OR DELETION OF YOUR TRANSMISSIONS OR DATA, (IV) BEHAVIOR OR STATEMENTS OF ANY THIRD PARTY IN CONNECTION TO THE SERVICE, AND (V) ANY OTHER CLAIM, INCIDENT, OR SITUATION ARISING FROM YOUR USE OF EAGLE SCRIPT'S SERVICES.
          <br />
          <p>
            Certain regions may restrict or disallow the exclusion or limitation of liability for consequential or incidental damages. If these laws apply to you, some of the above limitations may not be enforceable.
          </p>
        </p>

        <br />
        <p><strong>13. Intellectual Property & Rights</strong></p>
        <p>
          All content, code, design, and services are the intellectual property of EAGLE SCRIPT. You may not copy, reproduce, or distribute any part of the service without our prior written consent.
        </p>

        <br />
        <p><strong>14. General Provisions</strong></p>
        <p>
          (a) If any part of these Terms is deemed invalid, the rest remains enforceable.<br />
          (b) A failure to enforce any part of these Terms does not waive that provision.<br />
          (c) Claims related to these Terms must be brought within one year of the cause of action.<br />
          (d) We may assign our rights under these Terms without notice.
        </p>

        <br />
        <p>
          If you do not agree with these Terms of Service, you must not use any service offered by EAGLE SCRIPT.
        </p>
      </div>
      <ApexFooter />
    </div>
  );
};

export default ApexToS;